import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonMenuButton } from '@ionic/react';

// Constants
import { APP_CONFIG } from '../../constants';

// Helpers
import { extractConfigPage } from './../../helpers';

// Contexts
import { AppContext } from '../../contexts';

// Hooks
import { useVersion } from '../../hooks';

// Environments
import { environment } from '../../environments/environment';

export const HeaderComponent = ({ title='', color = 'primary', urlRedirect = '/', pageConfig = null, menuRef = null, showBackButton = true }) => {

    const appContext = useContext(AppContext);
    const location = useLocation();
    pageConfig = pageConfig || extractConfigPage(location);
    const { version } = useVersion( null);

    const getShowVersion = () => {

        return version && !environment.production ? '- Versión ' + version : '';
    }

    return (
        <>
            <IonHeader className="ion-no-border" translucent>

                <IonToolbar text-center mode="md" color={color}>
                    <IonButtons slot="start">

                        {
                            pageConfig.showMenuButton ?
                                appContext.network.connected && 
                                <IonMenuButton
                                    autoHide="false"
                                    menu={APP_CONFIG.MENU_ID}
                                    onClick={() => {

                                        if (menuRef != null) {

                                            menuRef.current.toggle();
                                        }
                                    }}
                                /> :
                                !appContext.isWeb && showBackButton && 
                                    <IonBackButton text=" " defaultHref={urlRedirect} />
                        }

                    </IonButtons>
                    {!appContext.isWeb && 
                        showBackButton ?                    
                        <IonTitle style={{ paddingLeft: 0 }} className="ion-text-left ion-text-uppercase">{`${title} ${ getShowVersion() }`}</IonTitle> :
                        <IonTitle style={{ paddingLeft: 50 }} className="ion-text-center ion-text-uppercase">{`${title} ${ getShowVersion() }`}</IonTitle>
                    }
                </IonToolbar>


            </IonHeader>
        </>
    )
}
